import './About.css';
import Header from './components/Header';
import { NavBar } from '../../utility/navBar/Navbar';
import { AboutSection } from './components/AboutSection';
import { Contact } from '../../utility/contact/Contact';
import { useEffect } from 'react';

export const About = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0});
    }, []);

    return (
        <section className={`about`}>
                <NavBar theme='light'/>
                <Header />
                <AboutSection />
                <Contact />
        </section>
        
    );
};